export interface TMessage {
  code: string;
  type: string;
  message: string;
}

// Reducer
export interface MessageState extends TMessage {
  showMessage: boolean;
}

// Acciones
export enum EnumActionsTypes {
  SHOW_MESSAGE = 'SHOW_MESSAGE',
  HIDE_MESSAGE = 'HIDE_MESSAGE',
}

interface SendShowMessageAction {
  type: typeof EnumActionsTypes.SHOW_MESSAGE;
  payload: TMessage;
}

interface SendHideMessageAction {
  type: typeof EnumActionsTypes.HIDE_MESSAGE;
}

export type ActionTypes = SendShowMessageAction | SendHideMessageAction;
